import { useMemo } from 'react';
import { useDi, API_BASE_URL } from '../../app/providers/DiProvider';
import { BookingsApi } from './bookings.api';

/** Resolves the BookingsApi client from the DI container (base URL comes from env). */
export function useBookingsApi(): BookingsApi {
  const di = useDi();
  return useMemo(() => new BookingsApi(di.resolve(API_BASE_URL)), [di]);
}
